import React, { Component,forwardRef } from 'react';
import { withFirebase } from '../Firebase';
import { withAuthorization } from '../Session';
import html2canvas from 'html2canvas';
import BotonesTriger from '../Botones/botonTrige'
import Cabecera from '../Cabecera/index_365'
import { DropzoneArea } from "material-ui-dropzone";
import ModalTutoriales,{traerTutoriales} from  '../Tutoriales/tutoriales'
import moment from 'moment';
import MaterialTable, { MTableBody } from 'material-table'
import {Paper,Box,TextField,IconButton,Grid,Backdrop,CircularProgress,
  Modal, Avatar,ListItemText, ListItemAvatar,ListItemSecondaryAction,Divider,List
 ,ListItem , InputLabel,MenuItem, FormControl,Select, Button,
 FormHelperText } from '@material-ui/core';
import { createTheme } from '@material-ui/core/styles';

import { ThemeProvider } from '@material-ui/styles';
import  green from '@material-ui/core/colors/green';
import  firebase2  from 'firebase'


import {AddBox,PictureAsPdf,Print,ArrowDownward,InsertDriveFile,Check,ChevronLeft,ChevronRight,Clear,DeleteOutline,Edit,
FilterList,FirstPage,LastPage,Remove,SaveAlt,Search,ViewColumn,CameraAlt,
NoteAdd,Delete} from '@material-ui/icons';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";



import {Textofield,checkBoxLectura,checkBoxModificar} from '../Fomulario/formulario'
import Copyright from '../Privacidad/copyright';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const theme = createTheme({
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: green[500],
    },
    secondary: {
      // This is green.A700 as hex.
      main: '#11cb5f',
    },
  },
});
const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

class Incidencias extends Component {
  tableRef = React.createRef()
  constructor(props) {
    super(props);
    this.state = {
      mComunidad:'', mCodigo:'',
      mFecha_reg:'',mEstado:'',  mTelefono1:'',mTelefono2:'',mEmail:'',mDescripcionfinal:'', mEstadoInci:'',
      mTipo:'',mPoliza:'',mPublicar:false,
      mActividad:'',
      mGremio:'', mDescripcion:'',mtexto_publicar:'',
      mRegistrador:'',mAperegistrador:'',
      mDireccion:'', mNumero:'', mPiso:'',
      mLetra:'',
      VideoTuto:[],
      Pdfs:[],
      abrirDescrip:false, 
      incis: [],
      comus: [],
      activs: [],
      gremios: [],
      estados:[],
      tipos:[],
      comunidad:'', 
      gremio:'',
      actividad:'',
      tipo:'',
      estado:'',
      mostrarTabla: true,
      salida_comus:{}, salida_tipos:{},salida_estados:{}, salida_gremios:{},
      lista_activ_filtrada:[],
      descripcion:'',
      abrir_documentos:false,
      usuarioLogueado:'',
      img365:'',
      cierrefinal:'',
      abrirCierre:false,
      rowData:[],
      cargada:false,
      open: false,
      onRowDataChange:'',
      mostrarAyuda:false,
      abrir_cambios:false,
      editar:false,
      tipoRegistro:''

  };
    this.handleChange = this.handleChange.bind(this);
    this.borrarFiltros = this.borrarFiltros.bind(this);
    this.busquedaAyuda = this.busquedaAyuda.bind(this)
    this.busquedaDatosGremio = this.busquedaDatosGremio.bind(this)
  
    this.handleImageLoaded = this.handleImageLoaded.bind(this)
    this.traerUsuarioLogueado = this.traerUsuarioLogueado.bind(this)
  }
  
  filterRef () {return ( React.createRef(""))}

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
     
    if (event.target.name === "comunidad"){

       let listaActi = this.busquedaAyuda(event.target.value)
       this.setState({ lista_activ_filtrada:listaActi  }) 

    }



  }

  handleSubmit(event) {
 //   alert('Your favorite flavor is: ' + this.state.value);
   // event.preventDefault();
  }

 componentDidMount() {
    traerTutoriales(this, 'Incidencias').then((data)=>{this.setState({VideoTuto:data})})
    this.traerUsuarioLogueado()
    this.props.firebase.comus().once('value', snapshot => {
      const usersObject = snapshot.val();
    if(usersObject){
        const comusList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }));
    
       comusList.sort(function (A, B) {
        var a =Number(A.Id.trim())
        var b =Number(B.Id.trim())
        if(!a){a=-1}
        if(!b){b=-1}
        if( a > b) {
          return 1;
        }
        if (a < b) {
          return -1;

        }
        // a must be equal to b
        return 0;
      })
      var salida_comus = {}
      comusList&&comusList.forEach(comu =>{
        const id  = comu.Id;
        if (id!== '')  {salida_comus[ id.toString() ] = id.toString()}
        
       } )  

      
      this.setState({  comus: comusList,  salida_comus:salida_comus   });
    }else{  this.setState({  comus: [],  salida_comus:[]   });}
    });
    
    this.props.firebase.activs().once('value', snapshot => {
      const usersObject = snapshot.val();
      const actividadList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }));
     // let salida_actividades={NA:
      let salida_actividades={}
      salida_actividades[ "" ] = ""
      actividadList&&actividadList.sort(function (a, b) {
        if (a.Nombre.toUpperCase() > b.Nombre.toUpperCase() ) {
          return 1;
        }
        if (a.Nombre.toUpperCase()  < b.Nombre.toUpperCase() ) {
          return -1;
        }
       // a must be equal to b
        return 0;
      });
      actividadList&&actividadList.forEach(actividad =>{
        const id  = actividad.Nombre;
        if (id!== '')  {salida_actividades[ id ] = id}
        
       } )
      this.setState({   activs: actividadList,salida_actividades:salida_actividades  });
    });
    this.props.firebase.gremios().once('value', snapshot => {
      const usersObject = snapshot.val();
      if(usersObject){
      const gremiosList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }));

 //     let salida_gremios= {NA:"NA"}
      let salida_gremios= {}
      gremiosList&&gremiosList.sort(function (a, b) {
        if (a.Nombre.toUpperCase() > b.Nombre.toUpperCase() ) {
          return 1;
        }
        if (a.Nombre.toUpperCase()  < b.Nombre.toUpperCase() ) {
          return -1;
        }
       // a must be equal to b
        return 0;
      });
      gremiosList&&gremiosList.forEach(gremio =>{
        const id  = gremio.Nombre;
        if (id!== '')  {salida_gremios[ id ] = id}
        
       } )

       salida_gremios["SIN GREMIO ASOCIADO"]="SIN GREMIO ASOCIADO"
      this.setState({  gremios: gremiosList,salida_gremios:salida_gremios  });
      }else{
        let salida_gremios= {}
        salida_gremios["SIN GREMIO ASOCIADO"]="SIN GREMIO ASOCIADO"
        this.setState({  gremios: [],salida_gremios:salida_gremios  });
      }
    });   
    this.props.firebase.estados().once('value', snapshot => {
      const usersObject = snapshot.val();
      const estadosList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }));
      let salida_estados={}
      estadosList&&estadosList.forEach(estado =>{
        const id  = estado.Nombre;
        if (id!== '')  {salida_estados[ id ] = id}
        
       } )
       
      this.setState({ estados: estadosList,salida_estados:salida_estados });
    });
  
    this.props.firebase.tipos().once('value', snapshot => {
      const usersObject = snapshot.val();
      const tiposList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }));
      let salida_tipos={}
      tiposList&&tiposList.forEach(tipo =>{
        const id  = tipo.Nombre;
        if (id!== '')  {salida_tipos[ id ] = id}
        
       } )
      
      this.setState({   tipos: tiposList,salida_tipos:salida_tipos   });
    })
    //this.buscarIncis();
  }
  
  traerUsuarioLogueado(){
    var user =  this.props.firebase.auth.currentUser;
    if(user) {
      var name = user.displayName;
      var email = user.email;
      var telefono= user.phoneNumber
     
      var usuario=[]
      
        this.props.firebase.users().once('value', function(snapshot) {
         
            const usersObject = snapshot.val();
         if (usersObject){
          var usuariosList = Object.keys(usersObject).map(key => ({
            ...usersObject[key],
            uid: key,
          }));
               usuariosList = usuariosList.filter(usu => usu.Clave ===user.uid) 
              usuario.push({
                Nombre: name,
                Apellido:usuariosList[0].Apellido,
                Comunidad:usuariosList[0].Comunidad,
                Codigo9: usuariosList[0].Codigo9,
                Telefono: telefono,
                Direccion: usuariosList[0].Direccion,
                Portal: usuariosList[0].Portal,
                Keyusuario: usuariosList[0].key,
                Email: email
              });
          
             
          }
        }).then(()=> { this.setState({usuarioLogueado:usuario})})
    }
  }

  componentWillUnmount() {
  //  this.props.firebase.incis().off();
    this.props.firebase.comus().off();
    this.props.firebase.activs().off();
    this.props.firebase.gremios().off();

  
  }
  buscarIncis() {
      this.setState({ open: true , mostrarTabla:false });
      const comus = this.state.comus
    this.props.firebase.incis ().once('value', snapshot => {
        const usersObject = snapshot.val();
      if(usersObject){
        const usersList = Object.keys(usersObject).map(key => ({
          ...usersObject[key],
          uid: key,
        }));
        
       
        
        let listafiltrada = this.filtrarIncis(usersList)

        let p = [];
        let fecha =''
        var options = {weekday: "long", year: "numeric", month: "long", day: "numeric", hour: "numeric", hour12:"false"};
        listafiltrada.forEach(inci=> {
          //quitamos los boorados
         var comus1= comus.filter(comu => comu.Id===inci.Comunidad) 
          if(!inci.Borrado&&comus1&&comus1.length>0){
              fecha= new Date(inci.Codigo)
            
              p.push({
                uid:inci.uid,  
                tipo:inci.Tipo,
                fecha_reg_ful: fecha.toLocaleString("es-ES", options),
                estado:inci.Estado,
                actividad:inci.Actividad,
                nombre_comu: comus1[0].Nombre,
                comunidad:inci.Comunidad,
                gremio:inci.Proveedor,
                email:inci.email,
                registrador:inci.NombreRegistrador,
                codigo: inci.Codigo,
                direccion: inci.Direccion,
                numero: inci.Numero,
                piso:inci.Piso,
                letra:inci.Letra,
                portal:inci.Portal,
                descripcion: inci.Descripcion,
                texto_publicar:(inci.Texto_publicar ? inci.Texto_publicar:''),
                texto_publicarfinal:(inci.Texto_publicar ? inci.Texto_publicar:''),
                Email:inci.Email,
                telefono1:inci.Telefono1,
                telefono2:inci.Telefono2,
                fecha_reg:moment(fecha).format('DD/MM/YYYY HH:mm:ss') ,
                imagen_reg: inci.Imagen,
                imagen: inci.ImagenUrl,
                ImagenesUrl:inci.ImagenesUrl,
                ayudaBusqueda: this.state.activs,
                fecha_ultima_modificacion: inci.Fecha_Modificacion,
                ultima_modificacion: inci.Ultima_Modificacion,
                borrado: inci.Borrado,
                aperegistrador: inci.ApellidoRegistrador,
                telefono: inci.TelefonoUsuario,
                poliza: inci.Poliza,
                publicar:(inci.Publicar ? inci.Publicar:false),
                hayFichero:(inci.hayFichero ? inci.hayFichero:false)
              })
          }
        });
        p.sort(function (a, b) {
          if (a.uid< b.uid) {
            return 1;
          }
          if (a.uid > b.uid) {
            return -1;
          }
         // a must be equal to b
          return 0;
        });
        this.setState({       incis: p,       open: false,       mostrarTabla: true     });   
      
      }else {
        this.setState({       incis: [],       open: false,       mostrarTabla: true     });   
      }
      
      }) 
      
    
      
  }
  busquedaAyuda (comunidad){

    if (!comunidad){return []}
    var comun = this.state.comus.filter(comuni => comuni.Id===comunidad)
  
    let melon = Object.entries(comun[0].ActivGremios ).map(([key, val]) => ({
      "Actividad": key , "Gremio": val ,  
    })); 
    var busquedAyuda =[]
    if(melon&&melon.length >0){
        busquedAyuda=  this.state.activs.filter(function(actividad) {
              var  esta=[]
              
                esta=  melon.filter(acti => acti.Actividad === actividad.uid) 
              
              if(esta.length >0){return true}
              return false
        })
    // if(busquedAyuda.length===0){busquedAyuda=[]}
        busquedAyuda= busquedAyuda.concat("")
    
       return busquedAyuda;
    } 
    return []
  }
  busquedaDatosGremio (comunidad, actividad){

        var comun = this.state.comus.filter(comuni => comuni.Id===comunidad)      
        let melon = Object.entries(comun[0].ActivGremios ).map(([key, val]) => ({
          "Actividad": key , "Gremio": val ,  
        }));   
        var activi = this.state.activs.filter(acthi => acthi.Nombre===actividad)      
        
        var resul2 = []
        if(melon&&melon.length >0){
            var resul=  melon.filter(act => act.Actividad===activi[0].uid)
            if(resul&&resul.length>0){resul2 = this.state.gremios.filter(gremio => gremio.uid=== resul[0].Gremio )}
        
        } 
        return resul2
  }
  filtrarIncis(incis){
    let listafiltrada= incis;
    if(this.state.comunidad!=='')
      {listafiltrada= listafiltrada.filter(inci => inci.Comunidad ===this.state.comunidad )};
    if(this.state.estado!=='')
      {listafiltrada= listafiltrada.filter(inci => inci.Estado ===this.state.estado )};
    if(this.state.gremio!=='')
      {listafiltrada= listafiltrada.filter(inci => inci.Proveedor===this.state.gremio )};
    if(this.state.actividad!=='')
      {listafiltrada= listafiltrada.filter(inci => inci.Actividad ===this.state.actividad )};
    if(this.state.tipo!=='')
      {listafiltrada= listafiltrada.filter(inci => inci.Tipo ===this.state.tipo )};


      return listafiltrada;
  }
  borrarFiltros(){ 
    this.filterRef['comunidad']=''
    this.filterRef['codigo']=''
    this.filterRef['estado']=''
    this.filterRef['tipo']=''
    this.filterRef['actividad']=''
    this.filterRef['gremio']=''
    this.filterRef['descripcion']=''
    this.filterRef['texto_publicar']=''
    this.filterRef['registrador']=''
    this.filterRef['aperegistrador']=''
    this.filterRef['direccion']=''
    this.filterRef['piso']=''
    this.filterRef['numero']=''
    this.filterRef['letra']=''    

        this.setState({comunidad:'', estado:'', gremio:'',actividad:'', tipo:'' })}


handleClickOpen = (pdffile) => () => {
       
          window.open(pdffile.url);  
        
          
        }      
handleClickBorrarFichero = (path) => {
          
          var respuesta = window.confirm("¿Quieres borrar el fihcero "+ path + "?")
            if(respuesta){
              this.setState({open:true,abrir_documentos:false})
              const rowData=this.state.rowData
              let ref = this.props.firebase.storage_propio_completo().child('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/');
              ref.child(path).getDownloadURL()
              .then((url)=>{
                this.props.firebase.inci(rowData.uid).once('value', snapshot => {
                  let incidencia = snapshot.val() 
                  if(incidencia){
                    var ImagenesUrl = incidencia.ImagenesUrl
                    if(ImagenesUrl&&ImagenesUrl.length>0){
                      ImagenesUrl=ImagenesUrl.filter(urle=> urle!==url)
                      if(ImagenesUrl.length===0){ incidencia.Imagen='NO'}
                      incidencia.Fecha_Modificacion= moment(new Date()).format('DD-MM-YYYY HH:mm')
                      incidencia.ImagenesUrl=ImagenesUrl
                      this.props.firebase.inci(rowData.uid).update(incidencia)
  
                    }
                   }

                })
                const p0 = new Promise ((resolve,reject)  => {  
                  resolve( ref.child(path).delete());
               
                  })
                  .catch(error => {
                      alert(error);
                  })
                
                p0.then( (data) => {this.compruebHayFichero(true)})
                
 
                
              })
            
            }

           
        };

compruebHayFichero = (desdeModal) =>{
  let rowData=this.state.rowData
  let listRef = this.props.firebase.storage_propio_completo().child('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/');
  listRef.listAll().then((res)=>{
    
      if(res.items&&res.items.length>0){
        rowData.hayFichero=true
        this.props.firebase.inci(rowData.uid+'/').update({'hayFichero':true}).then(()=>{

          this.buscarficheros('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/')
          this.setState({open:false})
          if(desdeModal){
            this.setState({abrir_documentos:true})
          }

        })

      }else{
        rowData.hayFichero=false
        this.props.firebase.inci(rowData.uid+'/').update({'hayFichero':false}).then(()=>{
          this.buscarficheros('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/')
          this.setState({open:false})
          if(desdeModal){            this.setState({abrir_documentos:true})}

        })

      }

      this.setState({rowData:rowData})
  })

}
onDrop(file) {
          this.setState({open:true})
          let rowData=this.state.rowData
            const putData = async () => {
              return Promise.all(file.map(fichero => { 
                return new Promise ((resolve,reject)  => { 
                this.props.firebase.storage_propio_completo('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/'+fichero.name).put(fichero)
                .then(()=>{

                  this.props.firebase.storage_propio_completo('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/'+fichero.name).getDownloadURL()
                  .then((url)=>{
                    resolve(url)
                  })
                
                }) 
              })
              } ))
            }
            putData().then(urls => { 
              
              this.props.firebase.inci(rowData.uid).once('value', snapshot => {
                let incidencia = snapshot.val() 
                if(incidencia){
                  var ImagenesUrl = (incidencia.ImagenesUrl&&incidencia.ImagenesUrl.length>0 ? urls.concat(incidencia.ImagenesUrl): urls)
                  incidencia.ImagenesUrl=ImagenesUrl
                  incidencia.Imagen='SI'
                  incidencia.Fecha_Modificacion= moment(new Date()).format('DD-MM-YYYY HH:mm')
                  this.props.firebase.inci(rowData.uid).update(incidencia)
                 }
              })
              
              
              
              this.compruebHayFichero(false)})
        
       // }
      }


buscarficheros (Path) {   
        this.setState({Pdfs:[]})
        this.setState({open:true})
  //      var carpetas=[];
         var pdfs=[];
           
        let listRef = this.props.firebase.storage_propio_completo().child(Path);
        
        const p0 = new Promise ((resolve,reject)  => {
      
          listRef.listAll().then(function(res) {
   
              
            res.items.forEach(function(itemRef) {
              pdfs.push({
                  items:itemRef
      
              })          
            })
       
              resolve(pdfs)
              
            })
           
        
        })
        p0.then( (data) => { 
                 //     this.setState({dataCategoria3:carpetas})
                      
                       this.traerPDFS(pdfs)
      
        })
      
      }
traerPDFS  (items){
       if(items.length>0){ 
        const listRef2 = this.props.firebase.storage_propio_completo()
        var pdfs=[];
        let promises = items.map((itemRef) => {
          return   listRef2.child(itemRef.items.location.path).getDownloadURL() 
        });
        Promise.all(promises).then((downloadURLs) => {
          var i=0;
          items.forEach((itemRef) => {
                pdfs.push({
                id: i,
                Nombre: itemRef.items.name,
                url: downloadURLs[i] ,
                path: itemRef.items.location.path,
            //  fullpath: itemRef.items.fullPath,
                image: require('../../Imagenes/Mimetypes-pdf-icon.png'),  
              })
              i++;
            })
              pdfs = pdfs.filter(file => file.Nombre !== "temporal.txt")
                this.setState({Pdfs:pdfs})
                this.setState({open:false,abrir_documentos:true }) 
  
              });
      
        }else (this.setState({open:false,abrir_documentos:true})
        )
          //    this.setState({PDFS:pdfs})
       
      }
 
onChange = event => {this.setState({ [event.target.name]: event.target.value })}


cerrarGestionCambios (){
  this.setState({ abrir_cambios: false, rowData: [], editar:false })

}

handleImageLoaded = (bool) => () =>{  
  this.setState({cargada:bool})
}
cargarPDF= (id,tipo,rowData) => () =>{
  var input = document.getElementById(id);
  var input2 = document.getElementById("foto");
 
  new Promise(resolve => {
    
       if(rowData.imagen_reg==='SI'){
          html2canvas(input2, {
          logging: true,
          letterRendering: 1,
          allowTaint: false,
          useCORS: true
      
          }).then(canvas => {
          
            resolve(canvas.toDataURL())

            })
      }else {resolve("")}
  }).then((data2)=> { 
   
                         const imagen =  'data:image/png;base64,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='
                  
                         html2canvas(input).then(canvas => {    
                          var data = canvas.toDataURL()
              
                           
                       
                              var pdfExportSetting = {
              
                            
                                footer: {
                                  columns: [
                                    { text: 'www.comuidad365.es', link: 'http://www.comunidad365.es', alignment: 'center', fontSize: 12, color:"green" }
                                  ]
                                },
                                content: [
                                  {
                                    image: imagen,
                                    alignment: 'center',
                                    margin:5,
                                    width: 200,
                                    height:25
                                  },
                                  {
                                    image: data,
                                    alignment: 'center',
                          
                                    width: 500,
                                    maxHeight:700
                                   // height:(canvas.height>675 ?  675:canvas.height)
                                   
                          
                                  },
                          
                              
                                ]
                                
                          
                              }; 
                          
                          var fecha = new Date()
                          var mes = fecha.getMonth() + 1
                          if (mes < 10) {mes = '0' + mes};
                          var fecha_reg= fecha.getDate() + mes + fecha.getFullYear()+"_" +rowData.codigo +".pdf"
                      
                          if(tipo==="guarda"){pdfMake.createPdf(pdfExportSetting).download(fecha_reg);}
                          else if(tipo==="imprime"){
                            pdfMake.createPdf(pdfExportSetting).print();
                          }
                          else if(tipo==="genera"){pdfMake.createPdf(pdfExportSetting).open();}
                          
                        })

  })

}

rowAñadir(newData){

 return new Promise((resolve, reject) => {
    var ejecuta= true
        if(!newData.comunidad||newData.comunidad ==='' ){alert("la comunidad no puede ser un campo vacío");
                ejecuta=false}
        else if(!newData.tipo||newData.tipo ===''){alert("Por favor escoje un tipo de registro"); ejecuta=false}                      
        else if(newData.tipo==='INCIDENCIA'&&(!newData.actividad||newData.actividad ===''))
          {alert("La actividad no puede ser un campo vacío"); ejecuta=false}

       else if       (!newData.descripcionfinal||newData.descripcionfinal === "")
          {alert("El campo descripción no puede ser vacío")
          ejecuta=false}

                
       if(ejecuta){
          newData.descripcion = "<" +this.state.usuarioLogueado[0].Nombre
          + "> "+   moment(new Date()).format('DD-MM-YYYY HH:mm') +": "+ newData.descripcionfinal
        

          if( newData.texto_publicarfinal===''){
            newData.texto_publicar =   moment(new Date()).format('DD-MM-YYYY HH:mm') +": "+ newData.descripcionfinal
          }else{ newData.texto_publicar =   moment(new Date()).format('DD-MM-YYYY HH:mm') +": "+ newData.texto_publicarfinal}

          newData.descripcionfinal=''
          newData.texto_publicarfinal=''

         if(newData.tipo!== 'INCIDENCIA'){newData.actividad=''}
         if(newData.tipo !== 'SINIESTRO'){newData.poliza=''}
          const fecha_reg=moment(new Date()).format('DD-MM-YYYY HH:mm')
          this.props.firebase.incis().push({
            Borrado: false,
            Comunidad:  newData.comunidad, 
            Actividad: newData.actividad,
            Codigo: firebase2.database.ServerValue.TIMESTAMP,
            Descripcion: newData.descripcion,
            Texto_publicar:  newData.descripcion,
            Email: newData.Email,
            Estado: "ABIERTA",
            Imagen: "NO",
            Poliza: newData.poliza,
            NombreRegistrador: this.state.usuarioLogueado[0].Nombre,
            ApellidoRegistrador: this.state.usuarioLogueado[0].Apellido,
            Proveedor: newData.gremio,
            Telefono1: newData.telefono1,                                          
            Telefono2:  newData.telefono2,
            Publicar:  (newData.publicar ? newData.publicar:false),
            //Direccion: 
            Tipo: newData.tipo,
            Direccion: this.state.usuarioLogueado[0].Direccion,
            Portal: this.state.usuarioLogueado[0].Portal,
            email: this.state.usuarioLogueado[0].Email,
            TelefonoUsuario:  this.state.usuarioLogueado[0].Telefono,
            Fecha_Modificacion:fecha_reg,
            Ultima_Modificacion: this.state.usuarioLogueado[0].Nombre+ "  email:"+ this.state.usuarioLogueado[0].Email

          }).then((clave)=>{
              if(clave) {
              this.props.firebase.inci(clave.key).once('value', snapshot => {
               const incidencia = snapshot.val() 
                newData.estado='ABIERTA'
                newData.uid=clave.key
                newData.fecha_reg=fecha_reg
                newData.imagen_reg='NO'
                newData.texto_publicar= newData.descripcion
                newData.Fecha_Modificacion=fecha_reg
                newData.codigo=incidencia.Codigo
                newData.registrador= this.state.usuarioLogueado[0].Nombre
                newData.aperegistrador= this.state.usuarioLogueado[0].Apellido
                newData.direccion= this.state.usuarioLogueado[0].Direccion
                newData.portal= this.state.usuarioLogueado[0].Portal
                newData.email= this.state.usuarioLogueado[0].Email
                newData.Letra= this.state.usuarioLogueado[0].Letra
             
                var data= this.state.incis
                data=data.concat(newData)
                this.setState({incis:data})
                alert('La incidencia se ha creado correctamente')
                this.setState({descripcionfinal:""})
                resolve(true)
              
              
              })
               
            }
         
             
            })
        } else {  
     //     this.setState({descripcionfinal:""})
          resolve(false)} 

  })
}

rowActualiza (newData, oldData) {

  return new Promise((resolve,reject) => {

     if (newData.estado!==oldData.estado||newData.tipo!==oldData.tipo
          ||newData.descripcion!==oldData.descripcion||newData.actividad!==oldData.actividad||
          newData.descripcionfinal!==""||  newData.publicar!==oldData.publicar ||
          newData.texto_publicar!==oldData.texto_publicar||
          newData.texto_publicarfinal!==oldData.texto_publicarfinal) {
          if(!newData.comunidad||newData.comunidad ==='' ){
            alert("la comunidad no puede ser un campo vacío");   reject(); return}
          if(!newData.tipo||newData.tipo ===''){alert("Por favor escoje un tipo de registro");  reject(); return}
          if(newData.tipo==='INCIDENCIA'&&(!newData.actividad||newData.actividad ==='')){alert("La actividad no puede ser un campo vacío");  reject(); return}
          if(!newData.descripcion||newData.descripcion ===''){alert("El campo descripción no puede ser vacío");
          reject(); return}
      
          if(newData.estado==='CERRADA'&&newData.descripcionfinal ===''){
             alert("Introduce una descripción final para cerrar la incidencia"); 
             reject(); return}
      
      
           var registroDescripcion= newData.descripcion 
          let fecha=  moment(new Date()).format('DD-MM-YYYY HH:mm')
        
          
          if(newData.estadoInci&&newData.estadoInci!==''&&newData.estadoInci!=='CERRAMOS'){
            registroDescripcion =  registroDescripcion + '\n' + newData.estadoInci +  ": <" +this.state.usuarioLogueado[0].Nombre
            + "> "+ fecha 
           
             newData.estadoInci=''
            
           
          }
          if(newData.descripcionfinal !== ""){
            if(newData.estado==='CERRADA'){
              registroDescripcion =  registroDescripcion + '\nCERRAMOS :<' +this.state.usuarioLogueado[0].Nombre
              + "> "+ fecha +
              ": "+ newData.descripcionfinal
              newData.descripcionfinal=''
            }else{
              registroDescripcion =  registroDescripcion + '\n<' +this.state.usuarioLogueado[0].Nombre
              + "> "+ fecha +
              ": "+ newData.descripcionfinal
              newData.descripcionfinal=''
            }
          }
          var data = this.state.incis;
          newData.descripcion= registroDescripcion
          newData.texto_publicar= newData.texto_publicarfinal
          newData.ultima_modificacion= this.state.usuarioLogueado[0].Nombre+ "  email:"+ this.state.usuarioLogueado[0].Email
          newData.fecha_ultima_modificacion =fecha
          
          data[data.indexOf(oldData)] = newData;
          this.setState({incis:data }); 
          if(newData.tipo !== 'SINIESTRO'){newData.poliza=''}
          if  (newData.tipo==='CONSULTA'){  
            this.props.firebase.inci(newData.uid).update({
              Descripcion: registroDescripcion,
              Texto_publicar:newData.texto_publicar,
              inciLeida:[],
              Estado: newData.estado,
              Publicar: newData.publicar,
        //     Imagen: "NO",
              NombreRegistrador: newData.registrador,
              Tipo: newData.tipo,
              email: newData.email,
              Fecha_Modificacion:newData.fecha_ultima_modificacion,
              Ultima_Modificacion:  newData.ultima_modificacion

            }).then(() => { 
               alert('Registro actualizado correctamente')
              this.setState({descripcionfinal:""})
              resolve(true)
              })
          }
          else{
            const Registro={
              'Actividad': newData.actividad,
              'Descripcion': registroDescripcion,
              'Texto_publicar':newData.texto_publicar,
              'Email': newData.Email,
             'Estado': newData.estado,
              'Poliza': newData.poliza,
              inciLeida:[],
           //   Imagen: "NO",
           'Direccion':newData.direccion,
           'Piso':newData.piso,
           'Numero':newData.numero,

           'Letra':newData.letra,
           'Escalera':newData.escalera,
           'Portal':newData.portal,

           'NombreRegistrador': newData.registrador,
              'ApellidoRegistrador':newData.aperegistrador,
              'Comunidad':newData.comunidad,
              'Codigo':newData.codigo,
              'Proveedor': newData.gremio,
              'Telefono1': newData.telefono1,                                          
              'Telefono2':  newData.telefono2,
              'Publicar': newData.publicar,
             'Tipo': newData.tipo,
              'email': newData.email,
              'Imagen':newData.imagen_reg,
              'ImagenesUrl':newData.ImagenesUrl,    
              'ImagenUrl':newData.imagen,
              'Fecha_Modificacion':newData.fecha_ultima_modificacion,
              'Ultima_Modificacion':  newData.ultima_modificacion
  
  
             }
            if( newData.tipo==='INCIDENCIA'&&(newData.actividad!==oldData.actividad || newData.gremio!==oldData.gremio)&&
              window.confirm("La actividad y/o el gremio han cambiado, ¿quieres enviar de nuevo el email de la incidencia a todos los implicados?" )){
            
             const despachoCode =this.props.firebase.despachoCode
             var emailIncidenciaReenvio = this.props.firebase.functions.httpsCallable('emailIncidenciaReenvio');
           
           
             emailIncidenciaReenvio({'BaseDatos':despachoCode.BaseDatos,'newData':Registro, 'Code':despachoCode.Code}).then(()=>{

                alert('Se ha realizado en el envío de email correctamente')
                }).catch((e)=>{
                  alert(e)
                })
                
             
            }
          
          this.props.firebase.inci(newData.uid).update({
            Actividad: newData.actividad,
            Descripcion: registroDescripcion,
            Texto_publicar:newData.texto_publicar,
            Email: newData.Email,
            Estado: newData.estado,
            Poliza: newData.poliza,
            inciLeida:[],
         //   Imagen: "NO",
            NombreRegistrador: newData.registrador,
            Proveedor: newData.gremio,
            Telefono1: newData.telefono1,                                          
            Telefono2:  newData.telefono2,
            Publicar: newData.publicar,
            Tipo: newData.tipo,
            email: newData.email,
            Fecha_Modificacion:newData.fecha_ultima_modificacion,
            Ultima_Modificacion:  newData.ultima_modificacion


            }).then(() => { 
              alert('Registro actualizado correctamente')
              this.setState({descripcionfinal:""})
              resolve(true)
            })
              
        }
        }
      else{  resolve(false)}
    })
    
}
render() {
    const { mostrarTabla } = this.state;
    const comus = this.state.comus
    const gremios = this.state.gremios;
    const activs = this.state.activs;
    const estados = this.state.estados;
    const tipos = this.state.tipos;
    const listaFiltrada= this.state.incis;
    const selecComunidad =  (nombre,onRowDataChange,rowData,disable ) =>
    <FormControl fullWidth margin='normal'>
    {!onRowDataChange&&<InputLabel shrink htmlFor="select-multiple-native">
      Comunidad
</InputLabel>}
    <Select

        disabled={disable}
        value={(onRowDataChange ? rowData[nombre] :this.state[nombre]) }
        onChange={e => {
          if(onRowDataChange){
            const newRowData = { ...rowData, comunidad: e.target.value };
            rowData.comunidad = e.target.value 
            let filtrado =this.busquedaAyuda( rowData.comunidad)
            newRowData.ayudaBusqueda=filtrado;

            onRowDataChange(newRowData);
          }else{
            
            this.setState({mComunidad:e.target.value})
            let filtrado1 =this.busquedaAyuda(e.target.value)
            var rowData1= rowData
            rowData1.ayudaBusqueda=filtrado1;
            this.setState({rowData:rowData})



          }
        }}    >
          {this.state.comus&&this.state.comus.map((gremio) => (
                        <MenuItem value={gremio.Id} >
                          {(onRowDataChange ? gremio.Id :gremio.Id+' '+gremio.Nombre) }
                        </MenuItem>
                      ))
          }
    </Select>
    </FormControl>
  
  const selecTipo = (nombre,onRowDataChange,rowData,disable )=>
    <FormControl fullWidth margin='normal'>
        {!onRowDataChange&&<InputLabel shrink htmlFor="select-multiple-native">
          Tipo
  </InputLabel>}
    <Select
        disabled={disable}
        value={(onRowDataChange ? rowData[nombre] :this.state[nombre]) }
        onChange={e => {
          var comunidad=[]
          var gremio=[]
        if(onRowDataChange){
          const newRowData = { ...rowData, tipo: e.target.value };
          rowData.tipo = e.target.value 
          newRowData.actividad = "" 
          newRowData.gremio = ""
          newRowData.telefono1 = ""
          newRowData.telefono2 = ""
          newRowData.Email = ""
          newRowData.poliza = ""
          
          if(e.target.value === 'SINIESTRO'){
            comunidad = comus.filter(comu =>comu.Id=== newRowData.comunidad)
            gremio= gremios.filter(grem => grem.uid===comunidad[0].Seguro)
            newRowData.actividad = 'SEGUROS'
            if(gremio&&gremio.length>0){
            newRowData.gremio= gremio[0].Nombre
            newRowData.Email= gremio[0].email
            newRowData.telefono1 = gremio[0].Telefono1
            newRowData.telefono2 = gremio[0].Telefono2
          //  newRowData.actividad = ""
            newRowData.poliza = comunidad[0].Poliza
            }else{
              newRowData.gremio= "SIN GREMIO ASOCIADO"
              newRowData.Email= ""
              newRowData.telefono1 = ""
              newRowData.telefono2 = ""
            //  newRowData.actividad = ""
              newRowData.poliza = ""

            }

          }

          onRowDataChange(newRowData);
        }else{
          this.setState({mTipo: e.target.value, mActividad:'', mGremio:'', mTelefono1:'',mTelefono2:'',mEmail:'',mPoliza:''})
          if(e.target.value === 'SINIESTRO'){
            comunidad = comus.filter(comu =>comu.Id=== this.state.mComunidad)
            gremio= gremios.filter(grem => grem.uid===comunidad[0].Seguro)
           // this.setState({mActividad:'SEGUROS'})
            if(gremio&&gremio.length>0){
              this.setState({mGremio: gremio[0].Nombre,mEmail:gremio[0].email,mTelefono1:gremio[0].Telefono1,
             mTelefono2:gremio[0].Telefono2,mPoliza:comunidad[0].Poliza})
            }else{
              this.setState({mGemio:"SIN GREMIO ASOCIADO"})
            }

          }


        }
        }}    >
          {this.state.tipos&&this.state.tipos.map((gremio) => (
                        <MenuItem value={gremio.Nombre} >
                          {gremio.Nombre}
                        </MenuItem>
                      ))
          }
    </Select>
    </FormControl>
  
  const selecEstado =  (nombre,onRowDataChange,rowData,disable ) =>  
    <FormControl fullWidth margin='normal'>
    {!onRowDataChange&&<InputLabel shrink htmlFor="select-multiple-native">
            Estado
    </InputLabel>}
    <Select
        disabled={disable}
        value={(onRowDataChange ? rowData[nombre] :(this.state.tipoRegistro==='modificacion' ? this.state[nombre]:'ABIERTA')) }
        onChange={e => {
          const newRowData = { ...rowData, estado: e.target.value };
          
        if(onRowDataChange){
          if(e.target.value === "CERRADA"){
           if(!rowData.descripcionfinal||rowData.descripcionfinal===''){
             alert('Debes introducir una descripción final para justificar el cierre')
             newRowData.estado = "ABIERTA"
            } else{
              newRowData.estadoInci='CERRAMOS'

            }
         //   this.setState({abrirCierre:true, descripcion:newRowData.descripcion, rowData:rowData,onRowDataChange:onRowDataChange}) 
          
          }
           else if(e.target.value === "ABIERTA"){
            newRowData.estadoInci='ABRIMOS'
          }
          
          else if(e.target.value === "CANCELADA"){
            newRowData.estadoInci='CANCELAMOS'
          }
          
          else { newRowData.estado = e.target.value }
     
          onRowDataChange(newRowData);
        }else{
          this.setState({mEstado:e.target.value})
          if(e.target.value === "CERRADA"){
            if(this.state.mDescripcionfinal===''){
              alert('Debes introducir una descripción final para justificar el cierre')
              this.setState({mEstado:"ABIERTA"})
             } else{
              this.setState({mEstadoInci:'CERRAMOS'})
 
             }
          }
          else if(e.target.value === "ABIERTA"){
            this.setState({mEstadoInci:'ABRIMOS'})
        
          }
          else if(e.target.value === "CANCELADA"){
            this.setState({mEstadoInci:'CANCELAMOS'})
          }
      
        
        }

        }}    >
        {this.state.estados&&this.state.estados.map((gremio) => (
                        <MenuItem value={gremio.Nombre} >
                          {gremio.Nombre}
                        </MenuItem>
                      ))
          }
        </Select>
    </FormControl>

  const selectAct = (nombre,onRowDataChange,rowData,disable ) =>    
  <FormControl fullWidth margin='normal'>
  {!onRowDataChange&&<InputLabel shrink htmlFor="select-multiple-native">
          Activididad
  </InputLabel>}
    <Select
      disabled={disable}
      value={(onRowDataChange ? rowData[nombre] :this.state[nombre]) }
      onChange={e => {
        if(!e.target.value){ 
        if(onRowDataChange) {rowData[nombre] = ""}
        else{ this.setState({[nombre]:''})}
        }          
        if(e.target.value&&e.target.value!=="") {
        var gremio = this.busquedaDatosGremio((onRowDataChange ? rowData.comunidad :this.state.mComunidad) , e.target.value )
       if(onRowDataChange){
        var newRowData = { ...rowData, actividad: e.target.value };
        if(gremio&&gremio.length>0){
          newRowData.Email =gremio[0].email
          newRowData.gremio= gremio[0].Nombre
          newRowData.telefono1=gremio[0].Telefono1
          newRowData.telefono2=gremio[0].Telefono2
        }else{
          newRowData.Email ="SIN GREMIO ASOCIADO"
          newRowData.gremio= "SIN GREMIO ASOCIADO"
          newRowData.telefono1=""
          newRowData.telefono2=""
          }
          onRowDataChange(newRowData);
        }
       else{
        if(gremio&&gremio.length>0){
          this.setState({mEmail:gremio[0].email, mGremio: gremio[0].Nombre,mActividad: e.target.value,
          mTelefono1:gremio[0].Telefono1,mTelefono2:gremio[0].Telefono2})

        }else{
          this.setState({mEmail:"SIN GREMIO ASOCIADO", mGremio:"SIN GREMIO ASOCIADO",mActividad: e.target.value,
            mTelefono1:'',mTelefono2:''})
        
          }
        }
        }
      }}
    >
        {(rowData.ayudaBusqueda ?  rowData.ayudaBusqueda.map((gremio) => (
                  <MenuItem value={gremio.Nombre} >
                                {gremio.Nombre}
                              </MenuItem>
                            ))
                  :  this.state.activs.map((activ) => (
                  <MenuItem value={activ.Nombre} >
                      {activ.Nombre} 
                    </MenuItem>
                    ))
                  )}
                 </Select>
  </FormControl>
  return (     
      <Grid >
        <Cabecera/>
        <hr/>
          <Grid style={{ position: 'absolute', right: 20, top: 20 , maxWidth:"15%", maxHeight:"15%"}}>
          <Button variant="contained" color="primary" onClick={() => { this.setState({ mostrarAyuda: true }) }}>
            AYUDA (TUTORIALES)
          </Button>
        </Grid>
        <BotonesTriger/>      
        <ThemeProvider theme={theme}> 
      
         <Grid     container      direction="row"   justifyContent="space-around"   alignItems="center"  >      
            <FormControl styles= {{  minWidth: 120}} >
              <InputLabel id="demo-simple-select-label">Comunidad</InputLabel>
              <Select
                labelId="comunidad"
                id="comunidad"
                name ="comunidad"
                value={this.state.comunidad}
                onChange={this.handleChange}
              >
                <MenuItem value="">{""}</MenuItem> 
                {comus && comus.map(comu => (

                  <MenuItem value={comu.Id}>{comu.Id}</MenuItem>                 
                ))
                                 
   
            }
              </Select>
              <FormHelperText>Listado de comunidades</FormHelperText>
      
            </FormControl>
            <FormControl styles= {{  width:'100%'}} >
              <InputLabel id="demo-simple-select-label">Estado</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="estado"
                value={this.state.estado}
                onChange={this.handleChange}
              >
                <MenuItem value="">{""}</MenuItem> 
                {estados && estados.map(comu => (                  
                  <MenuItem value={comu.Nombre}>{comu.Nombre}</MenuItem>                
          
            ))}
              </Select>
              <FormHelperText>Estado de la Incidencia</FormHelperText>
              </FormControl>
            <FormControl styles= {{  width:'100%'}} >
              <InputLabel id="demo-simple-select-label">Actividades</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="actividad"
                value={this.state.actividad}
                onChange={this.handleChange}
              >
               
                {( (this.state.lista_activ_filtrada.length>0) ?                      
                      this.state.lista_activ_filtrada.map(comu => (                  
                      <MenuItem value={comu.Nombre}>{comu.Nombre}</MenuItem>                
                    ))
                    :
                    activs && activs.map(comu => (                  
                      <MenuItem value={comu.Nombre}>{comu.Nombre}</MenuItem>  
                      ))
                )}
              </Select>
              <FormHelperText>Listado de actividades</FormHelperText>
            </FormControl>
            <FormControl styles= {{  width:'100%'}} >
              <InputLabel id="demo-simple-select-label">Gremios</InputLabel>
              <Select
                labelId="gremio"
                id="demo-simple-select"
                name = "gremio"
                value={this.state.gremio}
                onChange={this.handleChange}
              >
                <MenuItem value="">{""}</MenuItem> 
                {gremios && gremios.map(comu => (                  
                  <MenuItem value={comu.Nombre}>{comu.Nombre}</MenuItem>                
          
            ))}
              </Select>
              <FormHelperText>Listado de gremios por nombres</FormHelperText>
            </FormControl>
            <FormControl styles= {{  width:'100%'}} >
              <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="tipo"
                value={this.state.tipo}
                onChange={this.handleChange}
              >
                <MenuItem value="">{""}</MenuItem> 
                {tipos && tipos.map(comu => (                  
                  <MenuItem value={comu.Nombre}>{comu.Nombre}</MenuItem>                
          
            ))}
              </Select>
              <FormHelperText>Tipo de incidencias</FormHelperText>
            </FormControl>
            <Button onClick={this.borrarFiltros} variant="outlined"  size="large" color="primary"  startIcon={<Delete />}>
                    BORRAR FILTROS
            </Button> 
            <Button  onClick={e => {this.buscarIncis()}} variant="outlined"  size="large" color="primary"  startIcon={<Search />}>
                    BUSCAR
            </Button>
            
         </Grid>
         {mostrarTabla&&!this.state.open&&
       
            <Paper style={{width:'98%', overflowX:'auto', margin:10}}>        
                          <MaterialTable 
                              components={{
                                Body: props => <MTableBody {...props} onFilterChanged={(columnId, value) => {
                                    props.onFilterChanged(columnId, value);
                                    const field= props.columns[columnId].field
                                    this.filterRef[field] = value
                                }} />
                                }}
                               tableRef={this.tableRef}
                               options={{
                                doubleHorizontalScroll:true,
                                exportButton: {
                                  csv: true,
                                  pdf: false
                                },
                                addRowPosition:'first',
                                exportDelimiter: ";",
                                filtering: true,
                                pageSize: 10,  
                                maxBodyHeight: "70vh",
                                pageSizeOptions:	[5, 10, 20],
                                headerStyle: {
                                  backgroundColor: 'green',
                                  color: 'white',
                                  paddingTop:5,
                                  paddingBottom:5
                                }
                              }}
                              detailPanel={[
                                {
                                  tooltip: 'Abrir Detalle',
                                  render: rowData => {
                                     let id_pdf= "Pdf_doc_"+ rowData.codigo
                                  return (
                                     <div   style={{
                                      fontSize: 15, padding: 10, background: "#f5da55",                                   
                                      color: 'primary',
                                      backgroundColor: 'azure',
                                      marginLeft:30,
                                      marginRight:30
                                      
                                    }}>
                                      <IconButton  
                                      
                                          onClick={this.cargarPDF(id_pdf,"genera",rowData)} color="primary" aria-label="upload picture" component="span">
                                          <PictureAsPdf />
                                      </IconButton>
                                         
                                      <IconButton  
                                   
                                          onClick={this.cargarPDF(id_pdf,"imprime",rowData)} color="primary" aria-label="upload picture" component="span">
                                          <Print />
                                      </IconButton>
                                         
                                      <IconButton 
                                     
                                          onClick={this.cargarPDF(id_pdf,"guarda", rowData)} color="primary" aria-label="upload picture" component="span">
                                          <SaveAlt />
                                      </IconButton>
                                  

                                      <hr/>
                                      <div id={id_pdf}  
                                        style={{
                                   
                                          fontSize: 15, padding: 10, background: "#f5da55",
                                          textAlign: 'start',
                                          color: 'primary',
                                          backgroundColor: 'azure',
                                          marginLeft:30,
                                          marginRight:30,
                                          maxWidth:900,
//                                          maxHeight:600
                                        }}
                                      >
                                        
                                      
                                        <Box fontWeight="fontWeightBold" m={1}> 
                                             <h3  style={{ color: 'red' }}>DETALLE {rowData.tipo} </h3>
                                              Clave incidencia: {rowData.codigo}
                                              <hr/>
                                              Fecha de Registro: {rowData.fecha_reg_ful}
                                              <hr/>
                                              Nombre de la comunidad a quien va dirigida: {rowData.nombre_comu}
                                              <hr/>
                                              Descripción:  <text style={{whiteSpace: "pre-wrap"}}> {"\n"} </text> 
                                              <text  style={{whiteSpace: "pre-wrap"}}> {rowData.descripcion} </text>
                                              <hr/>
                                              Fecha última Modificación : {rowData.fecha_ultima_modificacion} 
                                              <hr/>
                                              Usuario última Modificación : {rowData.ultima_modificacion} 
                                              <hr/>
                                              Imagen Registrada: {rowData.imagen_reg}
                                              <hr/>
                                          </Box>

                                        {(rowData.tipo!=='CONSULTA')&&
                                             
                                              <Box fontWeight="fontWeightBold" m={1}> 
                                                <h3  style={{ color: 'red' }}>DETALLE GREMIO</h3>
                                                  Gremio: {rowData.gremio}
                                                  <hr/>
                                                  Contacto Gremio: {rowData.telefono1} {rowData.telefono2}
                                                  <hr/>
                                                  Email Gremio: {rowData.Email}
                                                  <hr/>
                                              </Box>}
                                              {(rowData.tipo==='SINIESTRO')&&<Box fontWeight="fontWeightBold" m={1}> 
                                                  Póliza: {rowData.poliza}
                                                    <hr/>
                                              </Box>}
                                              <hr/>
                                  
                                         <Box fontWeight="fontWeightBold" m={1}> 
                                              <h3  style={{ color: 'red' }}>DETALLE REGISTRADOR</h3>
                                              Nomre: {rowData.registrador +" "+ rowData.aperegistrador} 
                                              <hr/>
                                              Teléfono: {rowData.telefono} 
                                              <hr/>
                                              Email Registrador: {rowData.email}
                                              <hr/>
                                              Dirección Registrador: {rowData.direccion}
                                              <hr/>
                                              Número: {rowData.numero}, Piso: {rowData.piso}, Portal: {rowData.portal}, Letra: {rowData.letra}                                             
                                             
                                            {//rowData.imagen_reg === 'SI'&&
                          //                      <Box width={500} marginLeft={50} my={5}>
                          //                         <img id={"foto"} alt=''  style={{width:'100%', height: '60%' }}  src={rowData.imagen}/>
                             //                   </Box>
                                              }          
                                             
                                        </Box>
                                        </div>
                                     
                                      
                                    </div>
                                    )
                                  },
                                }
                              ]}                
                              localization={{ 
                                body: { editRow:
                                 { deleteText: '¿Quieres borrar la Incidencia?' } }, 
                                                                
                                 header: {    actions: 'Acciones'
                                },
                              }}
                              title={ <h2  style={{ color: 'green' }}>INCIDENCIAS     </h2>}

                              columns={[
                                {
                                  title: 'Publicar', field: 'publicar',defaultFilter: this.filterRef['publicar'], 
                                  type: "boolean",
                                  render: rowData =>checkBoxLectura(rowData.publicar),
                                  editComponent: ({ onChange, onRowDataChange, rowData, ...p }) => (
                                    checkBoxModificar('publicar',false,rowData, onRowDataChange,null)
                                   )
                               },
                               
                                { title: 'Com', field: 'comunidad',defaultFilter: this.filterRef['comunidad'],    editable: 'onAdd', //lookup: this.state.salida_comus  ,
                                editComponent: ({ onChange, onRowDataChange, rowData, ...p }) => ( 
                                  selecComunidad('comunidad',onRowDataChange,rowData,false ) 
                                )},
                                { title: 'Codigo', field: 'codigo',defaultFilter: this.filterRef['codigo'],  editable: 'never'},  
                                { title: 'Fecha Registro', field: 'fecha_reg',defaultFilter: this.filterRef['fecha_reg'],   editable: 'never',
                              
                                customSort: (a, b) =>(Number(moment(new Date(a.codigo)).format('YYYMMDDHHmmss'))-Number(moment(new Date(b.codigo)).format('YYYMMDDHHmmss')))
                                    
                              },
                                { title: 'Estado', field: 'estado',defaultFilter: this.filterRef['estado'], editable:  'onUpdate', lookup: this.state.salida_estados , 
                                editComponent: ({ onChange, onRowDataChange, rowData, ...p }) => ( 
                                  selecEstado('estado',onRowDataChange,rowData,false )
                                    )   
                                  },
                         
                                { title: 'Tipo', field: 'tipo', defaultFilter: this.filterRef['tipo'], lookup: this.state.salida_tipos,
                                editComponent: ({ onChange, onRowDataChange, rowData, ...p }) => ( 
                                  selecTipo('tipo',onRowDataChange,rowData,!rowData.comunidad || rowData.estado=== "CANCELADA" || rowData.estado=== "CERRADA" )
                                         )   
                                },                     
                               {title: 'Actividad', field: 'actividad',defaultFilter: this.filterRef['actividad'], lookup: this.state.salida_actividades,
//                                { title: 'Actividad', field: 'Nombre', editable: 'onAdd', lookup: this.state.lista_actividades,
                                editComponent: ({ onChange, onRowDataChange, rowData, ...p }) => ( 
                                  selectAct('actividad',onRowDataChange, rowData,rowData.tipo !=="INCIDENCIA" || rowData.estado=== "CANCELADA" || rowData.estado=== "CERRADA")
                                    )   
                                   },
                                { title: 'Gremio', field: 'gremio',defaultFilter: this.filterRef['gremio'], editable: 'never',lookup: this.state.salida_gremios},
                                { title: 'Descripción (interna)', field: 'descripcion',defaultFilter: this.filterRef['descripcion'],  cellStyle: {
                                  width: 400,
                                  minWidth: 400
                                },
                                headerStyle: {
                                  width: 400,
                                  minWidth: 400
                                },
                                render: rowData =>
                                <div>
                                        <TextField  InputLabelProps={{ shrink: true }}
                                          margin="normal"
                                          fullWidth
                                          multiline
                                          rowsMax={5}
                                     
                                          id="descripcion"
                                          name="descripcion"
                                          value={rowData.descripcion}
                                          type="text"
                                        />
                                </div>,
                        
                                editComponent: ({ onChange, onRowDataChange, rowData, ...p }) => {
                                  if(!rowData.descripcionfinal){rowData.descripcionfinal=''}
                                  return(
                                  <div>
                                  <TextField  InputLabelProps={{ shrink: true }}
                                    margin="normal"
                                    disabled={rowData.estado==='CERRADA'}
                                    fullWidth
                                    multiline
                                    rowsMax={3}
                                    name="descripcionfinal"
                                    id="descripcionfinal"
                                    value={rowData.descripcionfinal}
                                  
                                    onChange={e => {
                                      const newRowData = { ...rowData, descripcionfinal: e.target.value };
                                      rowData.descripcionfinal = e.target.value 
                          
                                      onRowDataChange(newRowData);
                                    }}    
                                    variant="filled"
                                    type="text"
                                  />
                              </div>)
                                
                                  }   
                                  },                         
                                  { title: 'Texto a publicar', field: 'texto_publicar',defaultFilter: this.filterRef['texto_publicar'],  cellStyle: {
                                    width: 400,
                                    minWidth: 400
                                  },
                                  headerStyle: {
                                    width: 400,
                                    minWidth: 400
                                  },
                                  render: rowData =>
                                  <div>
                                          <TextField  InputLabelProps={{ shrink: true }}
                                            margin="normal"
                                            fullWidth
                                            multiline
                                            rowsMax={5}
                                            name="texto_publicar"
                                            id="texto_publicar"
                                          
                                            value={rowData.texto_publicar}
                                            type="text"
                                          />
                                  </div>,
                          
                                  editComponent: ({ onChange, onRowDataChange, rowData, ...p }) => {
                                    if(!rowData.texto_publicarfinal){rowData.texto_publicarfinal=''}
                                    return(
                                    <div>
                                    <TextField  InputLabelProps={{ shrink: true }}
                                      margin="normal"
                                      disabled={rowData.estado==='CERRADA'}
                                      fullWidth
                                      multiline
                                      rowsMax={3}
                                      name="texto_publicarfinal"
                                      id="texto_publicarfinal"
                                      value={rowData.texto_publicarfinal}
                                    
                                      onChange={e => {
                                        const newRowData = { ...rowData, texto_publicarfinal: e.target.value };
                                        rowData.texto_publicarfinal = e.target.value 
                            
                                        onRowDataChange(newRowData);
                                      }}    
                                      variant="filled"
                                      type="text"
                                    />
                                </div>)
                                  
                                    }   
                                    },    
                                
                                { title: 'Registrador', field: 'registrador',defaultFilter: this.filterRef['registrador'],  editable: 'never' },
                
                                { title: 'Apellido Registrador', field: 'aperegistrador' ,defaultFilter: this.filterRef['aperegistrador'],  editable: 'never'},
                
                                { title: 'Dirección Registrador', field: 'direccion' ,defaultFilter: this.filterRef['direccion'],  editable: 'never'},
                                { title: 'Número', field: 'numero' , defaultFilter: this.filterRef['numero'], editable: 'never'},
                                { title: 'Piso', field: 'piso' ,defaultFilter: this.filterRef['piso'],  editable: 'never'},
                           
                                { title: 'Letra/Puerta', field: 'letra' , defaultFilter: this.filterRef['letra'], editable: 'never'},
                          
                              ]}
                              onRowClick={(event, rowData, togglePanel) => {
                                this.setState({rowData:rowData, abrir_cambios:true,tipoRegistro:'modificacion',
                                  mComunidad:rowData.comunidad, mCodigo:rowData.codigo,
                                  mFecha_reg:rowData.fecha_reg,mEstado:rowData.estado,
                                  mTipo:rowData.tipo,mPublicar:rowData.publicar,
                                  mActividad:rowData.actividad,
                                  mGremio:rowData.gremio, mDescripcion:rowData.descripcion,mtexto_publicar:rowData.texto_publicar,
                                  mRegistrador:rowData.registrador,mAperegistrador:rowData.aperegistrador,
                                  mDescripcionfinal:'',
                                  mDireccion:rowData.direccion, mNumero:rowData.numero, mPiso:rowData.piso,
                                  mLetra:rowData.letra,mEmail:rowData.Email, 
                                  mPoliza:(rowData.poliza  ? rowData.poliza:''),
                                  mTelefono1:rowData.telefono1, mTelefono2:rowData.telefono2
            
                                  })
                                }}                         
                              icons={tableIcons}
                              actions={ [
                      
                                {
                                  //No conseguimos darle valor a rowData cuando va por render el icon
                                  icon:(event, rowData)=> <NoteAdd style={{ color:  green[500] }}/>,
                                  tooltip: 'Ajuntar documentación',
                                  position:'row',
                                  onClick: (event, rowData) =>{
                                    this.buscarficheros('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/')
                                      this.setState({ rowData:rowData})
                                  }
                                },
                                {
                                    icon:  () => <AddBox />,
                                    tooltip: 'Añadir un nuevo usuario',
                                    // This makes add button to appear in table toolbar instead for each row
                                    isFreeAction: true,
                                    onClick: (event, rowData) => {
                                      this.setState({abrir_cambios:true, editar:true, tipoRegistro:'nuevo',
                                      rowData:[], 
                                      mComunidad:'', mCodigo:'',
                                      mFecha_reg:'',mEstado:'',
                                      mTipo:'',mPublicar:false,
                                      mActividad:'',
                                      mGremio:'', mDescripcion:'',mtexto_publicar:'',
                                      mRegistrador:'',mAperegistrador:'',
                                      mDescripcionfinal:'',
                                      mDireccion:'', mNumero:'', mPiso:'',
                                      mLetra:'',mEmail:'', 
                                      mPoliza:'',
                                      mTelefono1:'', mTelefono2:''
                      })
                                 }
                              }
                              ]}
                              data={listaFiltrada}
                             
                             // onSelectionChange={(rows) => alert('You selected ' + rows.length + ' rows')}
                             // onSelectionChange={this.checkEnSeguro("hola")}
                             // onRowClick={(event, rowData, togglePanel) => alert('You selected rows')}
                     editable={{
                          onRowUpdate: (newData, oldData) =>this.rowActualiza(newData, oldData),
                          onRowDelete: oldData =>
                            new Promise(resolve => {

                              resolve(
                                
                                this.props.firebase.inci(oldData.uid+'/').update({
                                  Borrado: true,
                                  Fecha_Modificacion:firebase2.database.ServerValue.TIMESTAMP,
                                  Ultima_Modificacion:   this.state.usuarioLogueado[0].Nombre+ "  email:"+ this.state.usuarioLogueado[0].Email

                                  })      
                    
                               )
                                                       
                            }).then(()=>{ 
                                  var data = this.state.incis;
                                  var newData = oldData;
                                  
                                  newData.borrado=true

                                  data[data.indexOf(oldData)] = newData;
                                  this.setState({incis:data }); 
          
                                  var nuevalista =   this.state.incis
                                  nuevalista = nuevalista.filter(inci => inci.borrado===false)
                                  this.setState({incis:nuevalista });                                    
                                  this.componentDidMount()})  }}             
                              
                            />

                     
                  </Paper>
              }

<Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
              open={this.state.abrir_cambios}
              onClose={e=>this.cerrarGestionCambios()}

            >
            <Paper style={{ height: '60%', marginTop:'-10%',  width:'80%'}}>
                <Paper  style={{padding:10,      height: '100%', overflowY: 'auto',
              
              }}> 
          
                <h3 style={{ color: 'white', backgroundColor:'green', marginTop:'-0.5%' }}>Incidencia: {this.state.mCodigo} </h3>
               <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start" spacing={1}>
                <Grid container spacing={1}>
                  <Grid item  xs={12}sm={ (this.state.tipoRegistro==='modificacion' ? 4:10)} md={ (this.state.tipoRegistro==='modificacion' ? 4:10)}>
                  {!this.state.editar&&Textofield('mComunidad','Comunidad',true,null,this)}
                  {this.state.editar&&selecComunidad('mComunidad',null,this.state.rowData,this.state.tipoRegistro==='modificacion')}
                  </Grid>
                  {this.state.tipoRegistro==='modificacion'&&<Grid item  xs={12} sm={2} md={2}>
                  {Textofield ('mCodigo','Código',true,null,this)}
                  </Grid>}
                  {this.state.tipoRegistro==='modificacion'&&<Grid item xs={12} sm={2}  md={2}>
                      {Textofield ('mFecha_reg','Fecha Registro',true,null,this)}
                        
                  </Grid>}
                  {this.state.tipoRegistro==='modificacion'&&<Grid  item  xs={12} sm={2}  md={2}  style={{textAlign: "center", marginTop:'-0.5%'}}>
                  <h5 style={{  marginBottom:-2, color: 'white', backgroundColor:(this.state.editar ? 'green':'darkseagreen') }}>Documentación</h5>
        
                        <Button               
                             fullWidth
                             disabled={!this.state.editar}
                             onClick={(event) => {
                                const rowData=this.state.rowData
                                this.buscarficheros('incidencias/'+rowData.comunidad+"/"+rowData.codigo+'/')
                                this.setState({ rowData:rowData})
                            }}>
                           <NoteAdd style={{ color: (this.state.editar ? 'green':'darkseagreen') }}/>
                        </Button>
                      </Grid>}

                  <Grid item  xs={12} sm={2} md={2} style={{textAlign: "center", marginTop:'-0.5%'}}>
                    <h5 style={{  marginBottom:-2, color: 'white', backgroundColor:(this.state.editar ? 'green':'darkseagreen') }}>Publicar</h5>
                    {checkBoxModificar ('Publicar',!this.state.editar,this.state.rowData, null,this)}
                    </Grid>
                 
                </Grid>
                <Grid container spacing={1}>
                <Grid item sm={3} xs={12}>
                {!this.state.editar&&Textofield('mEstado','Estado',!this.state.editar,null,this)}
                {this.state.editar&&selecEstado('mEstado',null,this.state.rowData,this.state.tipoRegistro!=='modificacion')}
                  </Grid>
                  <Grid item sm={3} xs={12}>
                  {!this.state.editar&&Textofield ('mTipo','Tipo',!this.state.editar,null,this)}
                  {this.state.editar&&selecTipo('mTipo',null,this.state.rowData,!this.state.mComunidad || this.state.mEstado=== "CANCELADA" || this.state.mEstado=== "CERRADA" )}
                          
                  </Grid>
                  <Grid item sm={3} xs={12}>
                     {!this.state.editar&&Textofield ('mActividad','Actividad',!this.state.editar,null,this)}
                    { this.state.editar&&selectAct('mActividad', null, this.state.rowData, this.state.mTipo !=="INCIDENCIA" ||  this.state.mEstado=== "CANCELADA" ||  this.state.mEstado=== "CERRADA")}
                    </Grid>   
                    
                    <Grid item sm={3} xs={12}>
                    {Textofield ('mGremio','Gremio',true,null,this)}
                     
                    </Grid>       
                </Grid>
                <Grid container spacing={1}>
                <Grid item sm={(this.state.mTipo==='SINIESTRO' ? 3:4)} xs={12}>
                    {Textofield ('mEmail','Correo Gremio',true,null,this)}
                    </Grid>
                    <Grid item sm={(this.state.mTipo==='SINIESTRO' ? 3:4)} xs={12}>
                    {Textofield ('mTelefono1','Telefono 1 Gremio',true,null,this)}
                    </Grid>
                    <Grid item sm={(this.state.mTipo==='SINIESTRO' ? 3:4)} xs={12}>
                    {Textofield ('mTelefono2','Teléfono 2 Gremio',true,null,this)}
                    </Grid>

                    {this.state.mTipo==='SINIESTRO'&&<Grid item sm={3} xs={12}>
                    {Textofield ('mPoliza','Póliza asociada',true,null,this)}
                    </Grid>}
             
               </Grid>
            
                
               {this.state.tipoRegistro==='modificacion'&&<Grid container spacing={1}>
                <Grid item sm={4} xs={12}>
                    {Textofield ('mRegistrador','Registrador',true,null,this)}
                    </Grid>
                    <Grid item sm={4} xs={12}>
                    {Textofield ('mAperegistrador','Apellido Registrador',true,null,this)}
                    </Grid>
                    <Grid item sm={4} xs={12}>
                    {Textofield ('mDireccion','Dirección',true,null,this)}
                    </Grid>
             
               </Grid>}
            
      
            {this.state.tipoRegistro==='modificacion'&&<Grid container spacing={1}>
               <Grid item sm={4} xs={12}>
                    {Textofield ('mNumero','Número',true,null,this)}
             
                    </Grid>
                    <Grid item sm={4} xs={12}>
                    {Textofield ('mPiso','Piso',true,null,this)}
                    </Grid>
                    <Grid item sm={4} xs={12}>
                    {Textofield ('mLetra','Letra',true,null,this)}
                    </Grid>
                </Grid>}
                <Grid container spacing={1}>
               {this.state.tipoRegistro==='modificacion'&&<Grid item sm={12} xs={12}>
                    {Textofield ('mtexto_publicar','Texto a Publicar',!this.state.editar|| this.state.mEstado==='CANCELADA',null,this)}                              
                    </Grid>}
               {this.state.editar&&this.state.mEstado!=='CANCELADA'&&<Grid item sm={12} xs={12}>
                    {Textofield ('mDescripcionfinal',(this.state.tipoRegistro==='modificacion' ? 'Actualiza la descripción interna':'Añade la descripción'),false,null,this)}                              
                    </Grid>
                }
              {this.state.tipoRegistro==='modificacion'&&         <Grid item sm={12} xs={12}>
                    {Textofield ('mDescripcion','Descripción (Interna)',true,null,this)}                              
                    </Grid>}
                </Grid>
                  
                </Grid>
         
                </Paper>
                {!this.state.editar&&
               
                  <Button   variant="contained" 
                      onClick={e => {                        
                          this.setState({editar:true})
                      }}               
                      color="primary"
                      style={{top:'1%' }}
                  >Editar</Button>
                }
               {this.state.editar&&
               <>
                  <Button  variant="contained"    style={{top:'1%', backgroundColor:'orange' }}
                      onClick={e => { 
                        if(this.state.tipoRegistro==='nuevo')  {   this.setState({ abrir_cambios:false})}
                        else{
                        const rowData=this.state.rowData
                        this.setState({ abrir_cambios:true,editar:false, mEstado:rowData.estado,
                          mPublicar:rowData.publicar,
                          mTipo:rowData.tipo,
                          mActividad:rowData.actividad,
                          mGremio:rowData.gremio, mDescripcion:rowData.descripcion,mtexto_publicar:rowData.texto_publicar,
                          mEmail:rowData.email, mTelefono1:rowData.telefono1,mTelefono2:rowData.telefono2,
                          mPoliza: rowData.poliza, mDescripcionfinal:''
                        })
                      }
                      }}    
                      color="primary"

                  >Cancelar</Button>
          
                 
                  <Button variant="contained"   color="primary" type="submit"  style={{top:'1%', left:5 }}      
                    onClick={e => {
                      this.setState({editar:false})
                      const newData={...this.state.rowData ,comunidad:this.state.mComunidad, codigo:this.state.mCodigo,
                        fecha_reg:this.state.mFecha_reg,estado:this.state.mEstado,
                        tipo:this.state.mTipo,actividad:this.state.mActividad,                
                        gremio:this.state.mGremio, descripcion:this.state.mDescripcion,texto_publicar:this.state.mtexto_publicar,
                        texto_publicarfinal:this.state.mtexto_publicar,
                        registrador:this.state.mRegistrador,aperegistrador:this.state.mAperegistrador,
                        direccion:this.state.mDireccion, numero:this.state.mNumero, piso:this.state.mPiso,
                        letra:this.state.mLetra,Email:this.state.mEmail, descripcionfinal:this.state.mDescripcionfinal,
                        poliza:(this.state.mPoliza  ? this.state.mPoliza:''),
                        publicar:this.state.mPublicar,
                        telefono1:this.state.mTelefono1, telefono2:this.state.mTelefono2}                  
                   
                        if(this.state.tipoRegistro!=='nuevo')  {   
                          let guardar=false
                          if(this.state.abrir_cambios){guardar=true}
                          this.setState({open:true,abrir_cambios:false,abrirContraseña:false,mostrarTabla:false})
                    
                            this.rowActualiza(newData, this.state.rowData).then((data)=>{
                              if(data){this.setState({rowData:newData,mDescripcionfinal:'' , mDescripcion:newData.descripcion})}
                              else{  
                                const rowData=this.state.rowData
                                this.setState({ 
                                  mComunidad:rowData.comunidad, mCodigo:rowData.codigo,
                                  mFecha_reg:rowData.fecha_reg,mEstado:rowData.estado,
                                  mTipo:rowData.tipo,
                                  mActividad:rowData.actividad,
                                  mPublicar:rowData.publicar,
                                  mGremio:rowData.gremio, mDescripcion:rowData.descripcion,mtexto_publicar:rowData.texto_publicar,
                                  mRegistrador:rowData.registrador,mAperegistrador:rowData.aperegistrador,
                                  mDireccion:rowData.direccion, mNumero:rowData.numero, mPiso:rowData.piso,
                                  mLetra:rowData.letra,mEmail:rowData.Email, 
                                  mPoliza:(rowData.poliza  ? rowData.poliza:''),
                                  mTelefono1:rowData.telefono1, mTelefono2:rowData.telefono2,
                               

            
                             
                            //   mlastSignInTime:rowData.metadata.lastSignInTime,
                              // mcreationTime:rowData.metadata.creationTime
                              })
                            }
                            this.setState({open:false,mostrarTabla:true})
                            if(guardar){this.setState({abrir_cambios:true})}
                            })                
                        }else{
                          this.setState({abrir_cambios:false,open:true,mostrarTabla:false})
                          this.rowAñadir(newData).then((data)=>{
                            this.setState({abrir_cambios:true,open:false,mostrarTabla:true, editar:true})
                            if(data){ this.setState({abrir_cambios:false})}
                        })}
                    }}    
                  >Guardar</Button>
                  </>
                }
                </Paper>
            
            </Modal>
    


  <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}

              open={this.state.abrir_documentos}
            
              onClose={e=>this.setState({abrir_documentos:false})}
 
            >
              <Paper style={{ maxHeight: 650, overflow: 'auto', marginLeft: 20, marginRight: 20, marginTop: 20 }}>
             
                  <Paper style={{maxHeight: 200, overflow: 'auto'}}>    
                  <h3 style={{color:'green', marginLeft:20}} >DOCUMENTACIÓN ADJUNTA</h3>  
              
                  <List component="nav" dense="true"  aria-label="main mailbox folders" 
                  justifyContent="space-around" alignItems="center" >
                    {this.state.rowData.imagen&&
                    <Grid>
                      <Button
                      fullWidth variant='outlined' color="primary" onClick={() => { 
                        window.open(this.state.rowData.imagen);   }}>
                      
                       <ListItemAvatar>
       
                           <Avatar  style ={{color:'lightgreen', backgroundColor:green[500]}}>  
                                <CameraAlt/>
                           </Avatar>
                        </ListItemAvatar>
                            Imagen asociada de la incidencia
                       </Button>
                    </Grid>
                    
                        
                    }
                    {this.state.Pdfs&&this.state.Pdfs.map(actividad => (                  
                    <Grid>
                    <Divider />
                    <ListItem
                    button
                    selected={this.selectedIndex === actividad.Nombre}
                    onClick={this.handleClickOpen(actividad)}
                    >
                    <ListItemAvatar>
                        <Avatar  style ={{color:'lightgreen', backgroundColor:green[500]}}>  

                          <InsertDriveFile/>
                        </Avatar>
                      </ListItemAvatar>

                    <ListItemText primary={actividad.Nombre}/>
                    <ListItemSecondaryAction>

                              <IconButton edge="end" aria-label="delete"
                              tooltip='Para poder borrar el estado de la incidencia debe estar ABIERTA'
                                disabled= {this.state.rowData.estado==='CERRADA'||this.state.rowData.estado==='CANCELADA'}
                                onClick={(event) => this.handleClickBorrarFichero(actividad.Nombre)} 
                               >
                                
                                <Delete />
                              </IconButton>
                             
                          
                            </ListItemSecondaryAction>
                         </ListItem>                      
                       
                    </Grid>
                      
                    ))}
                </List>
                </Paper>   
                
                {this.state.rowData.estado!=='CERRADA'&&this.state.rowData.estado!=='CANCELADA'&&<DropzoneArea 
                        maxFileSize={10000000}
                        onDrop = {acceptedFiles => this.onDrop(acceptedFiles)}
                         showPreviewsInDropzone= {false} 
                         filesLimit={5}
                         showFileNames ={false}
                         dropzoneText = {"Arrastra el fichero o haz click aquí para cargarlo desde la ventana"}/>
                }
            
              </Paper>


            </Modal>  
            <Modal
              aria-labelledby="transition-modal-title"
               aria-describedby="transition-modal-description"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}

              open={this.state.mostrarAyuda}
              onClose={e=>this.setState({mostrarAyuda:false})}


            >
            {this.state.mostrarAyuda&&<ModalTutoriales Pdfs= {this.state.VideoTuto}/> 
          }
           </Modal>
         <Backdrop  color = 'primary' open={this.state.open}>
               <CircularProgress color="primary" />
         </Backdrop>    
         <Box mt={40}>
          <Copyright />
         </Box>
        </ThemeProvider>
        </Grid>
    );
  }

}

const condition = authUser => !!authUser;
export default withFirebase(withAuthorization(condition)(Incidencias));